// extracted by mini-css-extract-plugin
export default {"UtilityBoxItem":"index_UtilityBoxItem__VLlwm","childWrapper":"index_childWrapper__U84vm","image":"index_image__1dUsi"};